import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
function CreateEvaluationDialog(tabPage, parent) {
    var self = this;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
        Title: Bao.Session.GetMessage("msgOk"),
        Click: function () {
            if (!self.ValidateDialog()) {
                return;
            }
            self.DialogResult(true);
            self.Dialog.Close();
        },
        Enabled: ko.observable(true)
    }, {
        Title: Bao.Session.GetMessage("msgCancel"),
        Click: function () {
            self.Dialog.Close();
        },
        Enabled: ko.observable(true)
    }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogResult = ko.observable();
    self.DialogViewModel.FolderStructureChecklistId = ko.observable();
    self.DialogViewModel.FolderStructures = ko.observableArray([]);
    self.DialogViewModel.SelectedFolderStructureId = ko.observable(false);
    self.DialogViewModel.SelectedItem = ko.observable(null);
    self.DialogViewModel.Checklists = ko.observableArray([]);
    self.isDialogTerminated = ko.observable(false);
    var selectChecklistTemplateMessage = Bao.Session.GetMessage("msgSelectChecklistTemplateMessage");
    self.ValidateDialog = function () {
        var isComplete = true;
        const folderStructureChecklistId = self.DialogViewModel.FolderStructureChecklistId();
        if (!folderStructureChecklistId || folderStructureChecklistId === "00000000-0000-0000-0000-000000000000") {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, selectChecklistTemplateMessage, "info");
        }
        return isComplete;
    };
    self.OkClick = function () {
        if (this.ValidateDialog()) {
            this.CreateEvaluation(this.FolderStructureChecklistId(), this.ReportId());
            this.DialogResult(true);
            this.Dialog.Close();
        }
    };
    self.Show = function () {
        tabPage.IsLoading(true);
        self.init().then(function () {
            return Bao.get("Dialog/CreateEvaluation");
        }).then(function (view) {
            if (!self.isDialogTerminated()) {
                self.Dialog.ViewModel(self.DialogViewModel);
                self.Dialog.Template(view);
                var okButton = new BaoDialogViewModel.ButtonFactory(self.Dialog, Bao.Session.GetMessage("msgOk"), function () {
                    if (self.ValidateDialog()) {
                        self.DialogResult(true);
                        self.Dialog.Close();
                    }
                });
                self.Dialog.Buttons([okButton]);
                self.Dialog.Open();
                self.DialogViewModel.FolderStructureChecklistId("");
                self.DialogViewModel.SelectedItem(null);
            }
            tabPage.IsLoading(false);
        });
    };
    self.init = function () {
        var def = null;
        if (parent != null && parent.ReportViewModel != null) {
            def = Bao.post("Dialog/GetChecklistsByShiftbookId", JSON.stringify({
                shiftbookId: parent.ReportViewModel.ShiftbookId()
            }));
        } else if (parent != null && parent.infoVM != null && parent.infoVM().ShiftReport != null) {
            //Finito Info
            def = Bao.post("Dialog/GetChecklistsByShiftbookId", JSON.stringify({
                shiftbookId: parent.infoVM().ShiftReport.ShiftbookId()
            }));
        } else if (parent != null && parent.instructionVM && parent.instructionVM().ShiftbookId != null) {
            //Finito-Instruction ChecklistTab
            def = Bao.post("Dialog/GetChecklistsByShiftbookId", JSON.stringify({
                shiftbookId: parent.instructionVM().ShiftbookId()
            }));
        } else if (parent != null && parent.taskVM && parent.taskVM().ShiftbookId != null) {
            //Finito-Task ChecklistTab
            def = Bao.post("Dialog/GetChecklistsByShiftbookId", JSON.stringify({
                shiftbookId: parent.taskVM().ShiftbookId()
            }));
        } else {
            def = Bao.post("Checkware/Checklist/GetChecklists");
        }
        return def.then(function (result) {
            self.DialogViewModel.Checklists([]);
            if (Array.isArray(result)) {
                result.splice(0, 1);

                // if there is only 1 template to choose from, immediately destroy the dialog and set the FolderStructureChecklistId
                if (result.length == 1 && result[0].Checklists.length === 1) {
                    self.DialogViewModel.FolderStructureChecklistId(result[0].Checklists[0].FolderStructureChecklistId);
                    self.DialogResult(true);
                    self.Dialog.Destroy();
                    self.Dialog.Hide();
                    self.isDialogTerminated(true);
                }
                else {
                    self.DialogViewModel.FolderStructures(result);
                    self.DialogViewModel.FolderStructures().forEach(function (item) {
                        if (item.FolderStructureId == null) {
                            return;
                        }
                    item.isOpen = ko.observable(false);
                        item.Checklists.forEach(function (checklist) {
                            checklist.isSelected = ko.computed(function () {
                                return checklist.FolderStructureChecklistId == self.DialogViewModel.FolderStructureChecklistId();
                            });
                        });
                    });
                }
            }
        });
    };
    self.DialogViewModel.SelectItem = function (item) {
        self.DialogViewModel.FolderStructureChecklistId(item.FolderStructureChecklistId);
        self.DialogViewModel.SelectedItem(item);
    };
    self.DialogViewModel.ToggleOpen = function (item) {
        if (item && item.isOpen) {
            item.isOpen(!item.isOpen());
        }
    };
}
export default CreateEvaluationDialog;